export * from './modal-tab.component';
export * from './modal-info-tab/index';
